const initCartCount = function () {
    fetch('/cart-count')
        .then(response => response.json())
        .then(data => {
            document.getElementById('cart-count').textContent = data.count;
        });
}

export default initCartCount;
